import { ref } from 'vue';
import { OrderType } from '@/enums/OrderEnums';

/**
 * Selected mode (order-type tab) of the main POS V2 page. Module-scoped so it
 * survives in-app navigation (order workspace, table pages) — the admin
 * equivalent of -pos's `useState('pos-main-mode')` — and intentionally resets
 * on reload. A value that is disabled for the current branch (e.g. after an
 * in-app restaurant switch) is normalized by PosV2Page's resolveDefaultMode
 * watcher, so stale values are harmless.
 */
const mainMode = ref<OrderType>(OrderType.Seat);

export function usePosMainMode() {
  return { mainMode };
}
